import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../pages/HomePage.vue'),
    },
    {
      path: '/articles',
      name: 'articles',
      component: () => import('../pages/ArticleListPage.vue'),
    },
    {
      path: '/article/:id',
      name: 'article-detail',
      component: () => import('../pages/ArticleDetailPage.vue'),
    },
    {
      path: '/category/:slug',
      name: 'category',
      component: () => import('../pages/CategoryPage.vue'),
    },
    {
      path: '/tags',
      name: 'tags',
      component: () => import('../pages/TagPage.vue'),
    },
    {
      path: '/tag/:slug',
      name: 'tag',
      component: () => import('../pages/TagPage.vue'),
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: () => import('../pages/FeedbackPage.vue'),
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../pages/AboutPage.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('../pages/NotFoundPage.vue'),
    },
  ],
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) return savedPosition
    return { top: 0 }
  },
})

export default router
